import { OPENFREEMAP_STYLE } from '../newmobilemap/core/constants';
import { createBasemapMap } from './basemap-style';

export function createListingLocationMap(container, center, zoom, onPoint) {
    const map = createBasemapMap(window.maplibregl, { container, style: OPENFREEMAP_STYLE, center, zoom });
    map.addControl(new window.maplibregl.NavigationControl({ showCompass: false }), 'top-right');
    map.on('click', (event) => onPoint([event.lngLat.lng, event.lngLat.lat]));
    return map;
}
